<template>
    <div class="documentation">
        <div class="row">
            <div class="col-md-5">
                <Breadcumb title="Depots des résultas" :breadcumb-data="breadcumbData">
                </Breadcumb>
            </div>
        </div>
        <b-card no-body class="cardcontainer">
            <b-card-body>
                <b-tabs class="nav-tabs-top nav-responsive-xl">
                    <b-tab title="Upload des résultats" active>
                        <b-card-body>
                            <file-upload class="sr-only"
                                         :name="name"
                                         :post-action="postAction"
                                         :extensions="extensions"
                                         :accept="accept"
                                         :multiple="multiple"
                                         :directory="directory"
                                         :size="0"
                                         :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                         :drop="drop"
                                         :drop-directory="dropDirectory"
                                         :headers="headers"
                                         :add-index="addIndex"
                                         v-model="files"
                                         @input-filter="inputFilter"
                                         @input-file="inputFile"
                                         ref="upload" />
                            <b-dd split :right="isRTL" @click="$refs.upload.$el.querySelector('input').click()" class="mb-3">
                                <template slot="button-content">
                                    <i class="ion ion-md-add"></i> Ajouter des fichiers
                                </template>
                            </b-dd>
                            <b-btn v-if="files.length > 0" @click="$refs.upload.active = true" variant="success" class="mb-3" style="float:right">
                                <i class="ion ion-md-arrow-up" aria-hidden="true"></i> Commencer l'upload
                            </b-btn>
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Nom du fichier</th>
                                        <th>Tag</th>
                                        <th>Taille</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="file in files" :key="file.id">
                                        <td>
                                            <div class="filename">
                                                {{file.name | getFileName }}
                                            </div>
                                            <b-progress
                                                    :value="Number(file.progress)"
                                                    :variant="file.error ? 'danger' : ''"
                                                    :animated="file.active"
                                                    v-if="file.active || file.progress !== '0.00' && file.success === false"
                                                    height="6px" style="margin: 4px 0 0 0" />
                                        </td>
                                        <td>{{file.name | getTag }}</td>
                                        <td>{{ file.size/1024/1024 | fileSize }} MB</td>
                                        <td v-if="file.error">
                                            <b-badge variant="error">THE ERROR IS == {{file.error}}</b-badge>
                                        </td>
                                        <td v-else-if="file.success">
                                            <b-badge variant="success">Uploader</b-badge>
                                        </td>
                                        <td v-else-if="file.speed != '0.00'">
                                            <b-badge variant="warning">En cours</b-badge>
                                        </td>
                                        <td v-else>
                                            <b-badge variant="default">En attente</b-badge>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>
                                    <tr v-for="saveFile in saveFiles" :key="saveFile.id">
                                        <td>
                                            {{ saveFile.name }}
                                        </td>
                                        <td>{{ saveFile.tag.label }} [{{ saveFile.tag.code }}]</td>
                                        <td>--</td>
                                        <td>
                                            <b-badge variant="primary">Enregistré</b-badge>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-card-body>
                    </b-tab>
                </b-tabs>
            </b-card-body>
        </b-card>
    </div>
</template>
<style>
</style>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<script>
    import Breadcumb from '../components/breadcumb';
    import VJstree from 'vue-jstree'
    import {ADMIN_RESULTSURVEY_REQUEST, ADMIN_RESULTTAGS_REQUEST} from "../_store/administration/result/actiontypes";
    import VueUploadComponent from 'vue-upload-component'
    import Vue from 'vue';
    import resultPostUrl from '../_services/api/resultUpload'

    Vue.filter('fileSize', function (value) {
        if (!value) return ''
        const parts = String(value).split('.')
        return `${parts[0]}.${parts[1].slice(0, 2)}`
    });

    Vue.filter('getFileName', function (value) {
        if (!value) return ''
        const parts = String(value).split('_');
        return parts[1]
    });

    Vue.filter('getTag', function (value) {
        if (!value) return ''
        const parts = String(value).split('_');
        return parts[0]
    });

    function getChildrens(tag) {
        console.log("IM IN");
        return tag.childrens.map(children => {
            var childrens = [];
            if (children.childrens.length > 0){
                childrens  = getChildrens(children)
            }
            return {
                'show-checkbox': false,
                'text': children.label + ' [' + children.code + ']',
                'selected': true,
                'children': childrens,
                'opened': false,
            }
        })
    }

    export default {
        name: 'adminUserList',
        components: {Breadcumb, VJstree, FileUpload: VueUploadComponent},
        mounted() {
            this.$store.dispatch(ADMIN_RESULTSURVEY_REQUEST)
                .then(result => {
                    this.saveFiles = result.data.results;
                });
            this.$store.dispatch(ADMIN_RESULTTAGS_REQUEST, {full: 0})
                .then(result => {
                    this.treeData = result.data.tags.map(tag => {
                        let childrens = [];
                        if (tag.childrens.length > 0){
                            childrens = getChildrens(tag)
                        }
                        return {
                            'show-checkbox': false,
                            'text': tag.label + ' [' + tag.code + ']',
                            'children': childrens,
                            'opened': false,
                        }
                    });
                    console.log(this.treeData);
                });
        },
        data() {
            return ({
                tags: [],
                treeData: [],
                breadcumbData: [
                    { text: 'Depot des résultats', active: true}
                ],
                files: [],
                name: 'file',
                accept: 'image/png,image/gif,image/jpeg,image/webp',
                extensions: 'gif,jpg,jpeg,png,webp',
                // extensions: ['gif', 'jpg', 'jpeg','png', 'webp'],
                // extensions: /\.(gif|jpe?g|png|webp)$/i,
                minSize: 1024,
                multiple: true,
                directory: false,
                drop: true,
                dropDirectory: false,
                addIndex: false,
                thread: 3,
                saveFiles: [],
                headers: {
                    "Authorization": localStorage.getItem('token')
                },
                postAction: resultPostUrl
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    // Filter php html js file
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                    // Create a blob field
                    newFile.blob = ''
                    let URL = window.URL || window.webkitURL
                    if (URL && URL.createObjectURL) {
                        newFile.blob = URL.createObjectURL(newFile.file)
                    }
                    // Thumbnails
                    newFile.thumb = ''
                    if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                        newFile.thumb = newFile.blob
                    }
                }
            },
            // add, update, remove File Event
            inputFile(newFile, oldFile) {
                if (newFile && oldFile) {
                    // update
                    if (newFile.active && !oldFile.active) {
                        // beforeSend
                        // min size
                        if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                            this.$refs.upload.update(newFile, {error: 'size'})
                        }
                    }
                }
            },
        }
    };
</script>
